import MHeading from './MHeading.vue';

MHeading.install = (app) => {
  app.component('MHeading', MHeading);
};

export { MHeading };
